<div class="flex flex-col h-full bg-white overflow-hidden">
  <main class="flex-1 p-5 overflow-hidden">
    <div class="bg-gris-4 rounded-[10px] h-full flex items-center justify-center overflow-y-auto">
      <div class="flex flex-col gap-6 bg-white rounded-[14px] p-10 w-full max-w-[520px]">
        @if (status() === 'sent') {
        <!-- Confirmation d'envoi -->
        <div class="text-center">
          <h1 class="text-[19px] fg-noir-1 font-semibold tracking-tight mb-3">
            {{ 'reset_password.request.sent.title' | translate }}
          </h1>
          <p class="text-[14px] fg-gris-1 font-normal">
            {{ 'reset_password.request.sent.subtitle' | translate }}
          </p>
        </div>

        <div class="flex flex-col items-center gap-3 text-center bg-vert-3 rounded-lg p-6">
          <span class="material-icons fg-vert-1 text-[40px]">mail_outline</span>
          <h2 class="text-[16px] fg-noir-2 font-semibold m-0">
            {{ 'reset_password.request.sent.message_title' | translate }}
          </h2>
          <p class="text-[14px] fg-gris-1 m-0">
            {{ 'reset_password.request.sent.message_received' | translate }}
          </p>
          <p class="text-[14px] fg-gris-1 m-0">
            {{ 'reset_password.request.sent.message_if_valid' | translate }}
          </p>
          <p class="text-[14px] fg-noir-2 font-semibold m-0">
            {{ 'reset_password.request.sent.message_validity' | translate }}
          </p>
          <p class="text-[14px] fg-gris-1 m-0">
            {{ 'reset_password.request.sent.message_spam' | translate }}
            <button type="button" (click)="retry()"
              class="fg-vert-1 font-semibold underline cursor-pointer bg-transparent border-0 p-0">
              {{ 'reset_password.request.sent.retry' | translate }}
            </button>
          </p>
        </div>
        } @else {
        <!-- Demande de réinitialisation -->
        <div class="text-center">
          <h1 class="text-[19px] fg-noir-1 font-semibold tracking-tight mb-3">
            {{ 'reset_password.request.title' | translate }}
          </h1>
          <p class="text-[14px] fg-gris-1 font-normal">
            {{ 'reset_password.request.subtitle' | translate }}
          </p>
        </div>

        <div class="bg-vert-3 border-l-4 border-vert-1 rounded-lg p-4">
          <p class="text-[14px] fg-noir-2 m-0">
            {{ 'reset_password.request.info' | translate }}
          </p>
        </div>

        <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-6 w-full">
          <div class="flex flex-col">
            <label for="reset-email" class="flex items-center gap-2 text-[14px] fg-noir-2 font-semibold mb-2">
              <span class="material-icons text-[18px]">alternate_email</span>
              {{ 'reset_password.request.email_label' | translate }}
            </label>
            <input id="reset-email" type="email" formControlName="email" autocomplete="email"
              placeholder="{{ 'reset_password.request.email_placeholder' | translate }}"
              class="text-black w-full h-[58px] px-4 py-3 border border-gris-1-300 rounded-lg shadow-sm placeholder-gris-1-400"
              [class.border-red-500]="form.controls.email.invalid && form.controls.email.touched" />
            @if (form.controls.email.invalid && form.controls.email.touched) {
            <span class="text-[12px] fg-rose-1 mt-1">
              {{ 'reset_password.request.errors.invalid_email' | translate }}
            </span>
            }
          </div>

          <button type="submit" [disabled]="status() === 'submitting'"
            class="w-full flex justify-center items-center h-[58px] gap-3 py-3 px-4 rounded-lg shadow-sm text-sm font-medium text-white bg-vert-1 hover:brightness-95 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer"
            aria-label="{{ 'reset_password.request.submit_button' | translate }}">
            @if (status() === 'submitting') {
            <app-loader size="w-5 h-5" />
            } @else {
            <span class="material-icons">send</span>
            }
            <span>{{ 'reset_password.request.submit_button' | translate }}</span>
          </button>
        </form>
        }

        <div class="text-center">
          <a class="text-[14px] fg-gris-1 font-semibold no-underline hover:brightness-95 hover:underline transition-colors duration-150"
            [routerLink]="loginRoute">
            {{ 'reset_password.back_to_login' | translate }}
          </a>
        </div>
      </div>
    </div>
  </main>
</div>
